import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import {
  Account,
  RemindPasswordRequest,
  RequestForInvitationRequest,
  ResetPasswordRequest,
  UpdateAccountRequest,
} from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/accounts`);

/**
 * Accounts API client.
 */
export const accountsClient = {
  /**
   * Get accounts list
   */
  list: async (token: string) => client.get<Account[]>('', token),

  /**
   * Get my account details
   */
  getMe: async (token: string) => client.get<Account>('me', token),

  /**
   * Update my account
   */
  updateMe: async (data: UpdateAccountRequest, token: string) =>
    client.patch<void>('me', data, token),

  /**
   * Send request for invitation to a given product
   */
  requestForInvitation: async (data: RequestForInvitationRequest, token: string) =>
    client.post<void>('me/send_request_for_invitation', data, token),

  /**
   * Verify my account
   */
  verifyAccount: async (token: string) => client.post<void>('me/verify', {}, token),

  /**
   * Verify my account
   */
  resetPassword: async (data: ResetPasswordRequest, token: string) =>
    client.post<void>('me/password/reset', data, token),

  /**
   * Send password reminder
   */
  resendPassword: async (data: RemindPasswordRequest) => {
    const queryParams = {
      client_id: Config.client_id,
      redirect_uri: Config.redirect_uri,
      response_type: Config.response_type,
      code_challenge: Config.code_challenge,
      code_challenge_method: Config.code_challenge_method,
    };

    const queryString = Object.keys(queryParams)
      .filter((key) => queryParams[key] !== undefined && queryParams[key] !== null)
      .map((key) => `${key}=${queryParams[key]}`)
      .join('&');

    return client.post<void>(`me/password/remind?${queryString}`, data);
  },
};
